import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import Loader from '../components/block-components/loader/loader';
import { routeConstants } from '../services/constants/route-constants';
import ProctedRoutes from './protected-routes';


const AdminRoutes = lazy(() => import("./admin-route"));
const StateAdminRoute = lazy(() => import("./state-admin-routes"));
const LgaAdminRoute = lazy(() => import("./lga-admin-routes"));
const HomeRoutes = lazy(() => import("./home-route"));
const PrivateRoutes = lazy(() => import("./private-routes"));

function BaseRoute() {
  return (
    <Router>
      <Suspense fallback={<Loader/>}>
        <Routes>
          <Route element={<ProctedRoutes/>}>
            <Route path={`${routeConstants.admin}/*`} element={<AdminRoutes/>}></Route>
            <Route path={`${routeConstants.state_admin}/*`} element={<StateAdminRoute/>}></Route>
            <Route path={`${routeConstants.lga_admin}/*`} element={<LgaAdminRoute/>}></Route>
            <Route path={`${routeConstants.private}/*`} element={<PrivateRoutes/>}></Route>
          </Route>
          <Route path={'*'} element={<HomeRoutes/>}></Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default BaseRoute;
